module.exports = __webpack_public_path__ + "static/img/news3.de265f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news3.png
// module id = 09qX
// module chunks = 1